// Auto-generated by devextreme-license.
// Do not commit this file to source control.

export const licenseKey = 'LCPv1eia1INRf!J,g7_FZGJy:cy<n9bRKI>t!ei+69LVo6J->:<yY:+e-9LF!pJVNVYR%%ecBVn!:!%tS7N!B2QS%>7F+%L4@,Y+X,Y<J:L,yVQaVcH!FI<@eSL+d(7,-V7QLp_eip<RzS>S8eb!;ZiSj2RSF,%FHVi:y!Hde!+VpSL!!%R!@%<Qmk7@@!QFF!Qr-pK!$%pX<9K!!6%f<2pR)aKFQIp<;I%fB>%X<2p@6p<-)!jyQaNRQpg!F6<4$27y@G<-6p<dQI%!:aQ!)27@QI%4v>jzvaj@Fpg!v6<-:2%-v6_@:>Q4:G_@@9Qdv6<!F6<dFI7yFI7yFI7Ll';
